import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { InteractiveList } from '../InteractiveList';
import { ReactComponent as Mail } from '../../assets/mail.svg';
import { ReactComponent as Mail1 } from '../../assets/mail1.svg';

interface Props {}

export const Footer: React.FC<Props> = () => {
    const { t } = useTranslation();
    return (
        <footer>
            <div className="am_inner_footer">
                <div className="am_left">
                    <p>{new Date().getFullYear()}</p>
                    <p>{t('landing.footer.company')}</p>
                    <Link to="/gdpr">
                        <InteractiveList
                            text={t('landing.footer.link')}
                            name={'link'}
                            col={['#000000', '#000000']}
                        />
                    </Link>
                </div>
                <div className="am_right">
                    <a href="mailto:kontakt@auto-mat.nu">
                        <div className="am_mail">
                            <Mail />
                            <Mail1 />
                        </div>
                    </a>
                </div>
            </div>
        </footer>
    );
};
